import React from "react";
import {
  Box,
  Stack,
  Grid,
} from "@mui/material";
const ShippingPdf = React.forwardRef((props, ref) => {
  console.log("props", props);
  const [row] = React.useState(props.data)
  const [filter] = React.useState(props.filter)
  const [wgtUm] = React.useState(props.wgtUm)

  return (
    <div ref={ref}>

      <Stack spacing={2} >
        <Box
          sx={{
            display: 'none',
            displayPrint: 'block',

            fontSize: '16pt',
            fontWeight: '700',
            textAlign: "center"
          }}
        >
         Shipping History
        </Box>
        <Grid container sx={{ padding: "5px", border: "2px solid" }} spacing={1} direction="row" >
          {Object.keys(filter).map((k) =>

            <Grid item xs={12}  >{k + " : " + filter[k]}</Grid>
          )
          }

        </Grid>
       
      </Stack>

      <div className="spacing"></div>
      <table>
        <tr>
          <th>Part Number</th>
          <th>Mill Order Number</th>
          <th>End-User PO</th>
          <th>Mill Coil ID</th>
          <th>Proc. Coil ID</th>
          <th className="leftAlign">{wgtUm}</th>
          <th className="leftAlign">Pieces</th>
          <th>Gauge</th>
          <th className="leftAlign">Width</th>
          <th className="leftAlign">Length</th>
          <th>B/L</th>
          <th>Ship Date</th>
        </tr>
        {row.map((row, key) =>
             <tr className={  row.isTot === 1 ? "bold":''}>
              <td >{row.partNo}</td>
              <td>{row.cusPoNo}</td>
              <td>{row.eusrPoNo}</td>
              <td>{row.cusTagNo}</td>
              <td>{row.procrCoilStf}</td>
              <td className="leftAlign">{row.wgtStr}</td>
              <td  className="leftAlign">{row.pcsStr}</td>
              <td>{row.gaStr}</td>
              <td className="leftAlign">{row.wdthStr}</td>
              <td className="leftAlign">{row.lgthStr}</td>
              <td>{row.blNoStf}</td>
              <td>{row.shpDts}</td>
            </tr>
          



        )}

      </table>



    </div>
  );
});

export default ShippingPdf;
